import React from "react";
import { HeaderComponent } from "../Config/header";
import { FooterComponent } from "../Config/footer";
import { Link } from "react-router-dom";

const Team = () => {
  return (
    <div>
      <HeaderComponent></HeaderComponent>
      <div className="mb-5">
        {/* <div className="container my-5">
          <div className="row g-4 ">
            <div className="col-4">
              <Link to="/MonthlyAttendance">
                <div className="card text-center border-0 p-3">
                  <div
                    className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                    style={{
                      width: "65px",
                      height: "65px",
                      backgroundColor: "#0010a4",
                    }}
                  >
                    <i className="fa-regular fa-calendar-days fs-5x text-white"></i>
                  </div>
                  <div className="card-body p-0">
                    <p className="card-title mt-3">Monthly Attendance</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-4">
              <Link to="/BulkAttendance">
                <div className="card text-center border-0 p-3">
                  <div
                    className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                    style={{
                      width: "65px",
                      height: "65px",
                      backgroundColor: "#a3cb82",
                    }}
                  >
                    <i className="fa-solid fa-list-check fs-5x text-white"></i>
                  </div>
                  <div className="card-body p-0">
                    <p className="card-title mt-3">Bulk Attendance</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-4">
              <Link to="/ManualAttendance">
                <div className="card text-center border-0 p-3">
                  <div
                    className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                    style={{
                      width: "65px",
                      height: "65px",
                      backgroundColor: "#7c7b29",
                    }}
                  >
                    <i className="fa-solid fa-user-pen fs-5x text-white"></i>
                  </div>
                  <div className="card-body p-0">
                    <p className="card-title mt-3">Manual Attandance</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-4">
              <Link to="/TeamMembers">
                <div className="card text-center border-0 p-3">
                  <div
                    className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                    style={{
                      width: "65px",
                      height: "65px",
                      backgroundColor: "#ffa269",
                    }}
                  >
                    <i className="fa-solid fa-user-group fs-5x text-white"></i>
                  </div>
                  <div className="card-body p-0">
                    <p className="card-title mt-3">Team Members</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-4">
              <Link to="/LeaveApplication">
                <div className="card text-center border-0 p-3">
                  <div
                    className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                    style={{
                      width: "65px",
                      height: "65px",
                      backgroundColor: "#00a2a1",
                    }}
                  >
                    <i className="fa-solid fa-square-check fs-5x text-white"></i>
                  </div>
                  <div className="card-body p-0">
                    <p className="card-title mt-3">Leave Application</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-4">
              <Link to="/PendingLeaves">
                <div className="card text-center border-0 p-3">
                  <div
                    className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                    style={{
                      width: "65px",
                      height: "65px",
                      backgroundColor: "#eda400",
                    }}
                  >
                    <i className="fa-regular fa-hourglass-half fs-5x text-white"></i>
                  </div>
                  <div className="card-body p-0">
                    <p className="card-title mt-3">Pending Leaves</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div> */}
        <div className="container">
          <div className="">
            <h6 className="text-start">Team</h6>
            <hr></hr>
            <div className="row g-4 ">
              <div className="col-4">
                <Link to="/Subscribe">
                  <div className="card text-center border-0 p-3">
                    <div
                      className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                      style={{
                        width: "65px",
                        height: "65px",
                        backgroundColor: "#ffa269",
                      }}
                    >
                      <i className="fa-solid fa-user-group fs-5x text-white"></i>
                    </div>
                    <div className="card-body p-0">
                      <p className="card-title mt-3">Team Members</p>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-4">
                <Link to="/Subscribe">
                  <div className="card text-center border-0 p-3">
                    <div
                      className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                      style={{
                        width: "65px",
                        height: "65px",
                        backgroundColor: "#a3cb82",
                      }}
                    >
                      <i className="fa-solid fa-list-check fs-5x text-white"></i>
                    </div>
                    <div className="card-body p-0">
                      <p className="card-title mt-3">Bulk Attendance</p>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-4">
                <Link to="/Subscribe">
                  <div className="card text-center border-0 p-3">
                    <div
                      className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                      style={{
                        width: "65px",
                        height: "65px",
                        backgroundColor: "#7c7b29",
                      }}
                    >
                      <i className="fa-solid fa-user-pen fs-5x text-white"></i>
                    </div>
                    <div className="card-body p-0">
                      <p className="card-title mt-3">Manual Attandance</p>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div>Leaves</div>
          <hr></hr>
          <div className="row g-4 ">
            <div className="col-4">
              <Link to="/Subscribe">
                <div className="card text-center border-0 p-3">
                  <div
                    className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                    style={{
                      width: "65px",
                      height: "65px",
                      backgroundColor: "#eda400",
                    }}
                  >
                    <i className="fa-regular fa-hourglass-half fs-5x text-white"></i>
                  </div>
                  <div className="card-body p-0">
                    <p className="card-title mt-3">Pending Leaves</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
          <div>Reports</div>
          <hr></hr>

          <div className="row g-4 ">
            <div className="col-4">
              <Link to="/Subscribe">
                <div className="card text-center border-0 p-3">
                  <div
                    className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                    style={{
                      width: "65px",
                      height: "65px",
                      backgroundColor: "#0010a4",
                    }}
                  >
                    <i className="fa-regular fa-calendar-days fs-5x text-white"></i>
                  </div>
                  <div className="card-body p-0">
                    <p className="card-title mt-3">Monthly Attendance</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <FooterComponent></FooterComponent>
    </div>
  );
};

export default Team;
